import React from "react";
import type { Localizer } from "@/main/react/Types";
import { readingTimeMinutes } from "@/main/discussion/ReadingTime";

/**
 * The "N min read" token for a byline or a card meta row (round-6 slice `2a`, D5 / A4).
 *
 * <p>A text token in an existing row, not a component with a box of its own: it inherits the row's
 * type and colour, and the caller owns the separator. Renders `null` when {@link readingTimeMinutes}
 * has nothing to show, so a caller can gate its separator on the same predicate
 * ({@link hasReadingTime}) and never leaves a dangling " · ".
 *
 * Design: `designs/01-now/2026-09-06-read-surface-completion-reading-time-and-author-stats-design.md` §3.
 */
export const READING_TIME_PLAYWRIGHT_ID = "reading-time";

export function hasReadingTime(bodyTextLength: number | null | undefined): boolean {
    return readingTimeMinutes(bodyTextLength) !== null;
}

export function ReadingTimeLabel({
    localizer,
    bodyTextLength,
}: {
    localizer: Localizer;
    bodyTextLength: number | null | undefined;
}): React.ReactElement | null {
    const minutes = readingTimeMinutes(bodyTextLength);
    if (minutes === null) {
        return null;
    }
    return (
        <span data-playwright-id={READING_TIME_PLAYWRIGHT_ID} data-reading-minutes={String(minutes)}>
            {localizer("discussion.readingTime", minutes)}
        </span>
    );
}
